<template>
  <div class="base64Print">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="$t.meta.printError"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(printUrl, index) in printUrls" :key="index">
        <img ref="printElement" :src="printUrl" />
      </div>
    </van-list>

    <div class="tool-bar" v-if="!error">
      <van-button block type="info" @click="onSave" :disabled="loading ? true : false">{{
        $t.meta.saveToAlbum
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, List } from "vant";

Vue.use(Form).use(Field).use(Button).use(List);

export default {
  name: "base64Print",
  data() {
    return {
      printUrls: [],
      api: "",
      param: {},
      page: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  mounted() {
    const { Api, Param } = this.$route.query;
    this.api = Api;
    this.param = JSON.parse(Param);
  },
  methods: {
    getList(page) {
      var param = this.param;
      param.PageIndex = page;
      this.$api.print[this.api](param)
        .then((res) => {
          this.printUrls = this.printUrls.concat(
            "data:image/jpeg;base64," + res.data.Base64Str
          );
          this.loading = false;
          this.error = false;

          this.page = this.page + 1;
          this.finished = this.page >= res.meta.total;
        })
        .catch(() => {
          this.loading = false;
          this.error = true;
        });
    },
    onSave() {
      let papers = this.$refs.printElement;
      for (var paper of papers) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
          element: paper,
          successText: this.$t.meta.saveSuccess,
          failText: this.$t.meta.saveError,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.base64Print {
  display: inline-block;
  width: 100%;
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      background: #fff;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .print-error {
    text-align: center;
    padding: 50px;
    font-size: 14px;
    color: #969799;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
